import { CATEGORIES } from './PermissionsChecker';

export const ANCILLARIES_TABS = [
  { key: 'manager', label: 'Manager', category: CATEGORIES.ANCILLARY_MANAGER },
  { key: 'mapping', label: 'Mapping', category: CATEGORIES.ANCILLARY_SUPPLIER },
  { key: 'distribution', label: 'Distribution', category: CATEGORIES.ANCILLARY_DISTRIBUTION },
];

export const getAncillariesTabPath = (key: string) => `/ancillaries/${key}`;